import React, {
  useContext,
  memo,
  useState,
} from 'react';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { appStore } from '../../../state/app';
import { ReactComponent as HeaderLogo } from '../../../assets/image/logo.svg';
// import HeaderHelpers from '../../../components/HeaderHelpers/HeaderHelpers';
import CustomBtn from '../../../generic/CustomBtn';
import PopUpWrapper from '../../../components/PopUp/components/PopUpWrapper';
import { requestApi } from '../../../utils/api-request';
import { toastifyMessage } from '../../../components/Toastify/Toastify';
// import LangSwitcher from '../../../components/MultiLangWrapper/LangSwitcher';
import storage from '../../../utils/storage';

const Header = ({ classStyle }) => {
  const translate = useIntl();
  const history = useHistory();
  const customClass = `header ${classStyle}`;
  // const [showHelpersPopUp, setShowHelpersPopUp] = useState(false);
  const [showLogOUtPopup, setShowLogOutPopup] = useState(false);
  const [loggingOut, setLoggingOut] = useState(false);
  const { state } = useContext(appStore);
  const {
    app, wallet,
  } = state;
  const { profile } = app;

  const logOutFromAcc = async () => {
    if (loggingOut) return;
    setLoggingOut(true);
    storage.set('logoutInProgress', true);
    const signedOut = await wallet.signOut();
    if (!signedOut) {
      const maintenance = wallet?.getLastMaintenance?.();
      if (maintenance?.warning) {
        toastifyMessage(maintenance.warning);
      } else {
        toastifyMessage('Logout failed. Please try again.');
      }
      storage.del('logoutInProgress');
      setLoggingOut(false);
      return;
    }
    try {
      await requestApi('DELETE', '/api/dashboard/log-out');
    } catch (error) {
      // Backend logout may return 401 if token already invalidated; wallet logout already succeeded.
      console.log(error,'log out failed');
    }
    storage.del('token');
    setShowLogOutPopup(false);
    setLoggingOut(false);
    history.push('/login');
    storage.del('logoutInProgress');
  };

  return (
    <header className={customClass}>
      <div className="header__wrapper">
        <div className="header__wrapper-logo">
          <HeaderLogo />
        </div>
        <div className="headerNav">
          {/* <LangSwitcher /> */}
          <div className="header__settings" onClick={() => history.push('/settings')}>
            <i className="icon-settings" />
            <div>{translate.formatMessage({ id: 'menu.setting' })}</div>
          </div>
          <span className="userName">
            {profile && Object.keys(profile).length > 0 ? profile.contact_person : translate.formatMessage({ id: 'header.setting' })}
          </span>
          <CustomBtn
            type="button"
            label={translate.formatMessage({ id: 'header.log-out' })}
            handleClick={() => setShowLogOutPopup(true)}
            customClass="log-out"
          />
          <a
            href="https://open-forest-protocol.gitbook.io/project-operator-guide"
            target="_blank"
            rel="noreferrer noopener"
            className="externalLink"
          >
            <span className="icon-info" />
            {translate.formatMessage({ id: 'header.help' })}
          </a>
          {/* <CustomBtn */}
          {/*  type="button" */}
          {/*  label={translate.formatMessage({id: 'header.helpers'})} */}
          {/*  handleClick={() => setShowHelpersPopUp(!showHelpersPopUp)} */}
          {/*  customClass="btn__btn-helpers" */}
          {/*  iconClass="icon-info" */}
          {/* /> */}
          {/* {showHelpersPopUp ? <HeaderHelpers showPopUp={showHelpersPopUp} setShowPopUp={setShowHelpersPopUp}/> : null} */}
        </div>
      </div>
      {showLogOUtPopup && (
        <PopUpWrapper widthParam="header__popup-wrapper" setShowPopUp={() => setShowLogOutPopup(false)}>
          <div className="header__popup">
            <h2 className="header__popup-title">
              {translate.formatMessage({ id: 'header.log-out' })}
            </h2>
            <p className="header__popup-desc">
              {translate.formatMessage({ id: 'header.helpers.desc' })}
            </p>
            <div className="header__popup-btns">
              <CustomBtn
                label={translate.formatMessage({ id: 'button-cancel' })}
                handleClick={() => setShowLogOutPopup(false)}
                customClass="btn__cancel"
              />
              <CustomBtn
                label={translate.formatMessage({ id: 'header.log-out' })}
                handleClick={logOutFromAcc}
                disabled={loggingOut}
                customClass="btn"
              />
            </div>
          </div>
        </PopUpWrapper>
      )}
    </header>
  );
};

export default memo(Header);
